/* RESPONSIBLE TEAM: team-ai-agent */
import { type TypeaheadConfig } from '@intercom/embercom-prosemirror-composer';
import { triggerCharacter } from '@intercom/embercom-prosemirror-composer/lib/composer/typeahead/trigger-character';

const contentTypeaheadConfig: TypeaheadConfig = {
  name: 'content',
  matcher: triggerCharacter('@', { allowSpaces: true }),
  component: 'ai-agent/guidance/content-typeahead',
};

export default contentTypeaheadConfig;
